import React, { useState, useEffect } from "react";
import { crearModulo, actualizarModulo, eliminarModulo } from "../../services/ModuloService";
import { obtenerEstructuraCompleta } from "../../services/api";

export default function MantenedorModulo() {
  const [modulos, setModulos] = useState([]);
  const [campos, setCampos] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [moduloForm, setModuloForm] = useState({
    moduloId: 0,
    campoId: 0,
    moduloNombre: "",
    codigoUnicoHash: "",
    ip: "",
    estadoId: 1,
  });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const estructura = await obtenerEstructuraCompleta();
      const camposApi = estructura.datos[0].campos || [];
      setCampos(camposApi);
      const modulosApi = camposApi.flatMap(campo =>
        campo.modulos.map(mod => ({
          ...mod,
          campoNombre: campo.campoNombre,
          campoId: campo.campoId
        }))
      );
      setModulos(modulosApi);
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

  const abrirNuevo = () => {
    setModuloForm({ moduloId: 0, campoId: campos[0]?.campoId || 0, moduloNombre: "", codigoUnicoHash: "", ip: "", estadoId: 1 ,categoriaId:1,vigencia:true});
    setEditando(false);
    setMostrarModal(true);
  };

  const abrirEditar = (mod) => {
     console.log("🛠️ Editando:", mod); // ← Añade esto para depurar
    setModuloForm({
      moduloId: mod.moduloId,
      campoId: mod.campoId,
      moduloNombre: mod.moduloNombre,
      codigoUnicoHash: mod.codigoUnicoHash,
      ip: mod.ip,
      estadoId: mod.estado,
      vigencia:true
      
    });
    setEditando(true);
    setMostrarModal(true);
  };

  const guardar = async () => {
    try {
      if (editando) await actualizarModulo(moduloForm);
      else await crearModulo(moduloForm);
      setMostrarModal(false);
      cargarDatos();
    } catch (error) {
      console.error("Error al guardar módulo:", error);
    }
  };

  const eliminarRegistro = async (mod) => {
    if (!window.confirm(`¿Eliminar módulo "${mod.moduloNombre}"?`)) return;
    try {
      await eliminarModulo(mod);
      cargarDatos();
    } catch (error) {
      console.error("Error al eliminar módulo:", error);
    }
  };

  return (
    <div className="p-6 bg-white rounded-md shadow-md font-sans">
      <header className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">💧 Mantenedor de Módulos</h1>
        <button
          onClick={abrirNuevo}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
        >
          + Nuevo Módulo
        </button>
      </header>

      <div className="overflow-x-auto border border-gray-200 rounded-md shadow-md">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {['ID','Nombre','Hash','Campo','IP','Estado','Acciones'].map(col => (
                <th key={col} className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {modulos.map(m => (
              <tr key={m.moduloId} className="odd:bg-white even:bg-gray-50 hover:bg-gray-100 transition">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{m.moduloId}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{m.moduloNombre}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{m.codigoUnicoHash}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{m.campoNombre}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{m.ip}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-block px-3 py-1 text-xs font-medium rounded-full ${m.estado===1?'bg-green-100 text-green-800':'bg-red-100 text-red-800'}`}> 
                    {m.estado===1?'Activo':'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap flex space-x-2">
                  <button
                    onClick={() => abrirEditar(m)}
                    className="px-3 py-1 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition"
                  >
                    Editar
                  </button>
                  <button
                    onClick={() => eliminarRegistro(m)}
                    className="px-3 py-1 border border-red-600 text-red-600 rounded-md hover:bg-red-50 transition"
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {mostrarModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-md shadow-lg p-6 font-sans">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {editando ? '✏️ Editar Módulo' : '➕ Nuevo Módulo'}
            </h2>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Campo</label>
                <select
                  value={moduloForm.campoId}
                  onChange={e => setModuloForm({ ...moduloForm, campoId: parseInt(e.target.value,10) })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                >
                  {campos.map(c => (
                    <option key={c.campoId} value={c.campoId}>{c.campoNombre}</option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nombre módulo</label>
                <input
                  type="text"
                  value={moduloForm.moduloNombre}
                  onChange={e => setModuloForm({ ...moduloForm, moduloNombre: e.target.value })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Hash único</label>
                <input
                  type="text"
                  value={moduloForm.codigoUnicoHash}
                  onChange={e => setModuloForm({ ...moduloForm, codigoUnicoHash: e.target.value })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">IP</label>
                <input
                  type="text"
                  value={moduloForm.ip}
                  onChange={e => setModuloForm({ ...moduloForm, ip: e.target.value })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                <select
                  value={moduloForm.estadoId}
                  onChange={e => setModuloForm({ ...moduloForm, estadoId: parseInt(e.target.value,10) })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                >
                  <option value={1}>Activo</option>
                  <option value={2}>Inactivo</option>
                </select>
              </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
              <button
                onClick={() => setMostrarModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 transition"
              >Cancelar</button>
              <button
                onClick={guardar}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
              >Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
